import { useSelector } from 'react-redux';

import getIncompleteProfileFields from '@/middleware/lib/get-incomplete-profile-fields';
import {
  selectIsUserLoading,
  selectIsUserLoggedIn,
  selectUserProfile,
} from '@/store/slices/user';

const useProfileGate = () => {
  const isLoggedIn = useSelector(selectIsUserLoggedIn);
  const isLoading = useSelector(selectIsUserLoading);
  const profile = useSelector(selectUserProfile);

  const missingFields = getIncompleteProfileFields(profile);
  const hasProfile = !!profile;
  const isProfileComplete = hasProfile && missingFields.length === 0;

  return {
    isLoggedIn,
    isLoading,
    profile,
    hasProfile,
    isProfileComplete,
    missingFields,
  };
};

export default useProfileGate;
